export const minutesAllowedCharacters = '0-59 (- * /)';
export const hoursAllowedCharacters = '0-23 (, - * /)';
export const dayOfMonthAllowedCharacters = '1-31 (, - * ? / L W)';
export const monthAllowedCharacters = '1-12 or JAN-DEC (, - * /)';
export const dayOfWeekAllowedCharacters = '1-7 or SUN-SAT (, - * ? L #)';
export const yearAllowedCharacters = '1970-2199 (, - * /)';
